module.exports = __webpack_public_path__ + "static/media/Alex-Jenkins-Illustration.cde79dc9.jpg";